if (typeof customElements.get("color-swatches") === 'undefined') {

    class ProductCardVariant extends HTMLElement {
        constructor() {
            super();
            this.swatches = this.querySelectorAll("span.color-swatch");
            this.card = this.closest(".card");
            this.variantImages = this.card.querySelectorAll(".color-swatch-variant");
            this.swatches.forEach((cardSwatch) => cardSwatch.addEventListener('mouseenter', this.productCardHoverIn.bind(this)));
            this.swatches.forEach((cardSwatch) => cardSwatch.addEventListener('focusin', this.productCardHoverIn.bind(this)));
            this.swatches.forEach((cardSwatch) => cardSwatch.addEventListener('mouseleave', this.productCardHoverOut.bind(this)));
            this.swatches.forEach((cardSwatch) => cardSwatch.addEventListener('focusout', this.productCardHoverOut.bind(this)));
        }
    
        productCardHoverIn(event){
            let swatchElement = event.target;
            let swatchColor = swatchElement.dataset.colorSwatch;
            let swatchVariantImage = this.card.querySelector(".color-swatch-variant[data-color-swatch='" + swatchColor + "']");
            if (swatchVariantImage) {
                swatchVariantImage.classList.add("opaque");
            }
            
        };
    
        productCardHoverOut(event){
            let swatchElement = event.target;
            let swatchColor = swatchElement.dataset.colorSwatch;
            let swatchVariantImage = this.card.querySelector(".color-swatch-variant[data-color-swatch='" + swatchColor + "']");
            if (swatchVariantImage) {
                swatchVariantImage.classList.remove("opaque");
            }
        }
    }
    
    customElements.define('color-swatches', ProductCardVariant);
    }
      